import moment from 'moment';
import PropTypes from 'prop-types';

export const START_DATE = 'startDate';
export const END_DATE = 'endDate';
export const HORIZONTAL_ORIENTATION = 'horizontal';
export const VERTICAL_ORIENTATION = 'vertical';
export const VERTICAL_SCROLLABLE = 'verticalScrollable';


export const ScrollableOrientationShape = PropTypes.oneOf([
  HORIZONTAL_ORIENTATION,
  VERTICAL_ORIENTATION,
  VERTICAL_SCROLLABLE,
]);

export function isBeforeDay(a, b) {

  if (!moment.isMoment(a) || !moment.isMoment(b)) {
    return false;
  }

  const aYear = a.year();
  const aMonth = a.month();

  const bYear = b.year();
  const bMonth = b.month();

  const isSameYear = aYear === bYear;
  const isSameMonth = aMonth === bMonth;

  if (isSameYear && isSameMonth) {
    return a.date() < b.date();
  }

  if (isSameYear) {
    return aMonth < bMonth;
  }

  return aYear < bYear;
}

export function isInclusivelyAfterDay(a, b) {
  if (!moment.isMoment(a) || !moment.isMoment(b)) {
    return false;
  }

  return !isBeforeDay(a, b);
}



// WEBPACK FOOTER //
// ./js/modules/reactDatesUtilities.js